/*
 * @Author: zhouxingtong
 * @Email: 495144492@qq.com
 * @Date: 2024-07-29 15:54:18
 * @LastEditors: zhouxingtong
 * @LastEditTime: 2025-01-07 17:16:12
 * @Description:
 */
import request from '@/axios'
import type { UserType, qrcodeLoginCheckType, loginFeiShuType } from './types'

interface RoleParams {
  roleName: string
}

// 登录
export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
  return request.post({ url: '/ecosystem/login', data })
}

//退出登录
export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/ecosystem/logout' })
}

export const qrcodeLogin = (): Promise<IResponse> => {
  return request.get({ url: '/admin/qrcodeLogin' })
}
//扫码登录
// export const qrcodeLoginCheck = (): Promise<IResponse> => {
//   return request.post({ url: '/admin/qrcodeLoginCheck', data })
// }

export const qrcodeLoginCheck = (data: qrcodeLoginCheckType): Promise<IResponse> =>
  request.post({ url: '/admin/qrcodeLoginCheck', data })

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}

export const loginFeiShu = (params: loginFeiShuType): Promise<IResponse<string[]>> => {
  return request.post({ url: '/admin/feishuLogin', params })
}
